// extracted by mini-css-extract-plugin
module.exports = {"submit-button-wrapper":"submit-button-wrapper__34Sm4","submission-evaluation-result-wrapper":"submission-evaluation-result-wrapper__cFpDX","breadcrumb":"breadcrumb__ZhecR"};